import React from 'react';

const OtherFooterMenu = () => {
    return (
        <footer className="inner-footer">
            <img src="images/mosque-bg.png" alt="" className="img-fluid mosque-bg" />
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="footer-wraper">
                            <p className="copyright-txt">© 2019 IAYA. All Rights Reserved.</p>
                            <ul className="list-unstyled">
                                <li><a href=""><img src="images/facebook.png" alt="" /></a></li>
                                <li><a href=""><img src="images/twitter.png" alt="" /></a></li>
                                <li><a href=""><img src="images/instagram.png" alt="" /></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default OtherFooterMenu